module.exports = __webpack_public_path__ + "static/cosi3-29619adca533dd2a23abcad611d4dd90.jpg";